import { head } from "@omni/utils/array.utils";
import { useEffect } from "react";

import { Selectable } from "@/components/CallToActions/Selectable/selectable.component";
import { ProductCallToAction } from "@/redux/modules/api/data/cart/@types/cart.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";
import { getKeyForCTA } from "@/utils/callToActions/callToActions.utils";
import { underScoreToCamelCase } from "@/utils/textUtils";

type Props = {
    cta: ProductCallToAction;
};

const SelectableContainer = ({ cta }: Props) => {
    const { t } = useGranite();
    const {
        openDialog,
        setActiveType,
        activeType,
        isExtendedActive,
        resetCurrentType,
        currentType
    } = useCallToActionsContext();
    const firstAction = head(cta.actions);
    const closable = cta.actions.every((a) => a.closable);

    const ctaKey =
        isExtendedActive && activeType
            ? underScoreToCamelCase(activeType.type)
            : getKeyForCTA(cta.actions);

    const description = t(`cta.${ctaKey}.description`);
    const title = t(`cta.${ctaKey}.title`);

    const confirmButtonText =
        cta.actions.length > 1
            ? t(`cta.general.button.submit`)
            : t(`cta.${ctaKey}.button.submit`);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        openDialog();
    }, []);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (
            (firstAction && !currentType) ||
            (firstAction && firstAction.type !== currentType?.type) ||
            cta.product?.sku !== currentType?.sku
        ) {
            resetCurrentType({
                type: firstAction?.type!,
                sku: cta.product?.sku
            });
        }
        if (!cta.product) {
            setActiveType({ type: firstAction?.type! });
        }
    }, [JSON.stringify(firstAction), cta.product?.sku]);

    const onSubmit = () => {
        setActiveType(currentType || null);
    };

    const activatedAction = cta.actions.find(
        (a) => a.type === activeType?.type
    );

    return (
        <Selectable
            onSubmit={onSubmit}
            closable={closable}
            description={description}
            title={title}
            confirmButtonText={confirmButtonText}
            cta={cta}
            activatedAction={activatedAction}
        />
    );
};

export default SelectableContainer;
